module.exports = __webpack_public_path__ + "img/viesa.b80ae32b.jpg";